import React from 'react'
import DashboardPopup from 'modules/dashboard/DashboardPopup/DashboardPopup'
import styled from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import Button from 'components/UI/Button/Button'
import Selector from './Selector'

export const Title = styled.div`
  color: ${colors.pink};
  font-size: 28px;
  text-align: center;
  margin-bottom: 15px;
`

export const SelectButton = styled(Button)`
  margin-top: 15px;
`

export const SizeButton = styled(Button)`
  margin-top: 15px;
`

export const ConfirmButton = styled(Button)`
  margin-top: 60px;
`

export const Content = styled.div`
  text-align: center;
`

export const SelectedChoice = styled.div`
  font-size: 28px;
  color: ${colors.darkPurple};
  margin: 10px 0 5px 0;
`

const PLANS = Array(20).fill({}).map((c, i) => (
  { nbSchools: i + 1 }
))

export default class SchoolsNumberPopup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selecting: false,
      selected: false
    }
  }

  selectNbClasses (o) {
    this.setState({
      selected: true,
      selecting: false,
      choice: o
    })
  }

  onSelectAction () {
    this.setState({
      selecting: true
    })
  }

  renderNotSelectedView () {
    return [<div key='1'><SelectButton block={false} onClick={this.onSelectAction.bind(this)}>Select</SelectButton></div>,
      <div key='2'><ConfirmButton disabled>Request Invoice</ConfirmButton></div>]
  }

  renderSelectingContent () {
    return <Selector options={PLANS.map(p => (
      { plan: p, label: `${p.nbSchools} School${p.nbSchools > 1 ? 's' : ''}`, info: `` }
    ))} onSelect={this.selectNbClasses.bind(this)} />
  }

  requestInvoice () {
    this.props.onSubmit([{ title: 'Type', answer: 'Multiple schools' }, { title: 'Number of schools', answer: `${this.state.choice.nbSchools}` }])
  }

  renderSelectedContent () {
    const { choice } = this.state
    return [
      <SizeButton key='1' onClick={this.onSelectAction.bind(this)}>{choice.label}</SizeButton>,
      <SelectedChoice key='2'>{choice.info}</SelectedChoice>,
      <Button key='3' bgColor={colors.success} onClick={this.requestInvoice.bind(this)}>Request Invoice</Button>
    ]
  }

  render () {
    return <DashboardPopup
      onCancel={this.props.onCancel}
    >
      <Title>
        How many schools do you need?
      </Title>

      <Content>
        { !this.state.selecting && !this.state.selected && this.renderNotSelectedView() }
        { this.state.selecting && this.renderSelectingContent() }
        { !this.state.selecting && this.state.selected && this.renderSelectedContent() }

      </Content>
    </DashboardPopup>
  }
}
